import { ProjectLocationModel } from './project-locations.model';

export interface ProjectLocationsInitialState {
  projectLocations: Array<ProjectLocationModel>;
}

export const projectLocationState: ProjectLocationsInitialState = {
  projectLocations: [],
};
